/**
 * Fail closed before an automated run can attach to a live Firebase project.
 * Normal desktop and browser launches do not set these flags.
 */
function assertE2eFirebaseSafety({ useEmulator, e2e, projectId }) {
  if (useEmulator && projectId === "rms-prod-ca-1") {
    throw new Error("Refusing to attach Firebase emulators to the production project rms-prod-ca-1.");
  }
  if (e2e && !useEmulator) {
    throw new Error("E2E runs must set REACT_APP_FIREBASE_EMULATOR=1 so they cannot write to a cloud Firebase project.");
  }
}

module.exports = { assertE2eFirebaseSafety };
